import loadable from '@loadable/component';

export const TgSiteWrapper = loadable(
  () => import(/* webpackChunkName: "tg-site" */ './TgSiteWrapper'),
);
